import { render, staticRenderFns } from "./MyPhotosView.vue?vue&type=template&id=1ab1c8be&scoped=true"
import script from "./MyPhotosView.vue?vue&type=script&lang=js"
export * from "./MyPhotosView.vue?vue&type=script&lang=js"
import style0 from "./MyPhotosView.vue?vue&type=style&index=0&id=1ab1c8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab1c8be",
  null
  
)

export default component.exports